import { Column, Entity, Index, JoinColumn, ManyToOne, Unique } from 'typeorm';
import { AutomationStepEntity } from './automation-step.entity';
import { BaseEntity } from './base.entity';

@Entity('_automation_step_connection')
@Unique(['fromStepId', 'toStepId', 'conditionKey'])
@Index(['fromStepId'])
@Index(['toStepId'])
@Index(['fromStepId', 'conditionKey'])
export class AutomationStepConnectionEntity extends BaseEntity {
	@Column({
		name: '_fk__from__automation_step__id',
		type: 'int',
		unsigned: true,
	})
	public fromStepId!: number;

	@Column({ name: '_fk__to__automation_step__id', type: 'int', unsigned: true })
	public toStepId!: number;

	@Column({
		name: '_condition_key',
		type: 'varchar',
		length: 255,
		default: "'next'",
		comment:
			'Key for routing connections - UUID for conditions, "next" for regular flow',
	})
	public conditionKey!: string;

	@Column({
		name: '_target_handle',
		type: 'varchar',
		length: 50,
		nullable: true,
		comment:
			'Target handle position where connection enters (e.g., "top-50", "right-25")',
	})
	public targetHandle?: string;

	@ManyToOne(() => AutomationStepEntity, { onDelete: 'CASCADE' })
	@JoinColumn({ name: '_fk__from__automation_step__id' })
	public fromStep!: AutomationStepEntity;

	@ManyToOne(() => AutomationStepEntity, { onDelete: 'CASCADE' })
	@JoinColumn({ name: '_fk__to__automation_step__id' })
	public toStep!: AutomationStepEntity;
}
